export interface SelectOption {
  value: string;
  label: string;
}

/** Выпадающий список в стиле дизайн-системы (поле ui-kit Field поддерживает только input). */
export function Select({
  label,
  value,
  onChange,
  options,
  required = false,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  required?: boolean;
}) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className="text-xs uppercase tracking-wider text-muted">
        {label}
        {required ? ' *' : ''}
      </span>
      <select
        value={value}
        required={required}
        onChange={(event) => onChange(event.target.value)}
        className="min-h-touch w-full rounded-field border border-line bg-ink-900 px-3 text-content"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
